"use client";
import PriceTag from "@/components/global/price-tag";
import Tag from "@/components/global/tag";
import { Button } from "@/components/ui/button";
import Image from "next/image";

import Link from "next/link";
import { toast } from "sonner";
import { addToCart } from "@/lib/cart-manager";
import { useLocale, useTranslations } from "next-intl";
import AddToWishlistButton from "./add-to-wishlist";
import Ratings from "./rating";
import { cn } from "@/lib/utils";

export default function ProductCard({ data, className }) {
  const locale = useLocale();
  const t = useTranslations("productCard");
  const discount = {
    type: data.discount_type,
    percentage: data.discount_percentage,
    to_be_applicable: data.to_be_applicable,
    gifted_number: data.gifted_number,
  };

  const productName =
    locale === "en"
      ? data.product_name_en
      : locale === "ar"
        ? data.product_name_ar
        : data.product_name;

  const description =
    locale === "en"
      ? data.description_en
      : locale === "ar"
        ? data.description_ar
        : data.description;

  function handleAddToCart() {
    addToCart(data);
    toast.success(t("addToCartSuccess"));
  }

  const isOutOfStock = data.is_out_of_stock === 1 || data.tmp_stock === 0;
  return (
    <div
      className={cn(
        "grid grid-rows-[1fr,50px] rounded-lg border border-muted bg-white transition-all hover:scale-[1.01]",
        className,
      )}
    >
      <Link
        href={`/product/${data.id_product}`}
        className="relative grid grid-rows-[250px,1fr] gap-2.5 p-2.5 pb-5"
      >
        <Tag
          className=" rounded-br-none rounded-tl-none"
          discount={discount}
          isOutOfStock={data.is_out_of_stock || data.tmp_stock === 0}
        />
        <Image
          className="h-[250px] w-full rounded-md object-contain"
          width={400}
          height={400}
          src={`${data.main_image}`}
          alt={`${data.product_name} image`}
          priority
        />
        <div className="flex flex-col gap-2.5">
          <h3 className="text-xl font-semibold">{productName}</h3>
          <p className="mb-auto line-clamp-2">{description}</p>
          <Ratings
            productId={data.id_product}
            rating={data.rating}
            ratingsNumber={data.ratings_number}
            productName={productName}
            hasBtn={false}
          />
          <PriceTag price={data.price} discount={discount} decimal={false} />
        </div>
      </Link>
      <div className="grid grid-cols-2 gap-2.5 p-2.5 pt-0">
        <AddToWishlistButton product={data} />
        <Button
          disabled={isOutOfStock}
          variant="secondary"
          onClick={handleAddToCart}
        >
          {t("addToCart")}
        </Button>
      </div>
    </div>
  );
}
